import React, { useState } from 'react';
import LeftSection from './LeftSection';
import MiddleSection from './MiddleSection';
import RightSection from './RightSection';
import PrintResults from './PrintResults';

const Home = () => {
  const [formData, setFormData] = useState({
    nasionToInion: '',
    preauricular: '',
    circumference: '',
    nomenclature: 'T3/T4',
  });
  const [submissionResults, setSubmissionResults] = useState(null);
  const [showResults, setShowResults] = useState(false);

  const handleFormSubmit = (data) => {
    const timestamp = new Date().toLocaleString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });
    setFormData(data);
    setSubmissionResults({ formData: data, timestamp, calculatedValues: {} });
    setShowResults(true);
  };

  const handleReset = () => {
    setFormData({
      nasionToInion: '',
      preauricular: '',
      circumference: '',
      nomenclature: 'T3/T4',
    });
    setSubmissionResults(null);
    setShowResults(false);
  };

  const handleCalculatedValues = (calculatedValues) => {
    if (submissionResults) {
      setSubmissionResults((prev) => ({
        ...prev,
        calculatedValues,
      }));
    } else if (showResults) {
      const timestamp = new Date().toLocaleString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      });

      setSubmissionResults({
        formData,
        calculatedValues,
        timestamp,
      });
    }
  };


  return (
    <section className="homepage brain-pointer-none">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-xl-4 col-lg-6 col-md-6 p-0">
            <LeftSection
              onFormSubmit={handleFormSubmit}
              formData={{
                formData: submissionResults?.formData,
                calculatedValues: submissionResults?.calculatedValues,
                timestamp: submissionResults?.timestamp,
              }}
              onReset={handleReset}
              isResultGenerated={showResults}
            />
          </div>

          <div className="col-12 col-xl-4 col-lg-6 col-md-6 p-0 mt-md-0 mt-4">
            <MiddleSection
              formData={formData}
              showResults={showResults}
              onCalculatedValues={handleCalculatedValues}
              isReset={!showResults}
            />
          </div>
          <div className="col-12 col-xl-4 col-lg-12 p-0 mt-xl-0 mt-4">
            <RightSection />
          </div>
        </div>
        {/* {showResults && submissionResults && (
          <div className="print-only">
            <PrintResults
              formData={submissionResults?.formData}
              calculatedValues={submissionResults?.calculatedValues}
              timestamp={submissionResults?.timestamp}
            />
          </div>
        )} */}
      </div>
    </section>
  );
};

export default Home;